import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-technology',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './technology.html',
  styleUrl: './technology.scss',
})
export class Technology {
  ts = inject(TranslationService);
  t = this.ts.t;

  steps = computed(() => [
    this.t().tech_step1, this.t().tech_step2, this.t().tech_step3,
    this.t().tech_step4, this.t().tech_step5, this.t().tech_step6,
  ]);

  features = computed(() => [
    { title: this.t().tech_feat1_title, desc: this.t().tech_feat1_desc },
    { title: this.t().tech_feat2_title, desc: this.t().tech_feat2_desc },
    { title: this.t().tech_feat3_title, desc: this.t().tech_feat3_desc },
    { title: this.t().tech_feat4_title, desc: this.t().tech_feat4_desc },
    { title: this.t().tech_feat5_title, desc: this.t().tech_feat5_desc },
    { title: this.t().tech_feat6_title, desc: this.t().tech_feat6_desc },
  ]);

  layers = computed(() => [
    { name: 'Hardware Layer - IP Cameras & Edge Devices', color: '#0066cc' },
    { name: 'Inference Layer - Image Identification Models', color: '#00d4ff' },
    { name: 'Storage Layer - Offline Database', color: '#22c55e' },
    { name: 'Sync Layer - Automatic Cloud Synchronization', color: '#f59e0b' },
    { name: 'Application Layer - Multi-Tenant Dashboard', color: '#ef4444' },
    { name: 'Analytics Layer - Real-Time Insights & Alerts', color: '#8b5cf6' },
  ]);
}